import { ApiMetric, ApiSalesFlowMetric } from "@incendium/api";
import { getMetricConfig } from "../services/metricFormatter";
import { metricMap as salesMetricMap } from "features/salesFlow/services/metricFormatter";
import { getCurrencySymbol } from "features/currency";
import { formatNumber, formatToKM } from "Helpers/numbers";
import { useSelectedProject } from "Hooks";
import { useCallback } from "react";

const useFormatMetric = (isSales?: boolean) => {
  const { selectedProject } = useSelectedProject();

  return useCallback(
    (
      metric: ApiMetric | ApiSalesFlowMetric,
      value?: number,
      options?: { isKM?: boolean },
    ) => {
      const currency = selectedProject?.currency
        ? getCurrencySymbol(selectedProject?.currency)
        : "$";

      if (isSales) {
        const m =
          salesMetricMap[
            ((metric as string) || "").split("\\")[0] as ApiSalesFlowMetric
          ];
        return m && m.format
          ? m.format(value || 0, currency)
          : options?.isKM
            ? formatToKM(value || 0)
            : formatNumber(value || 0);
      }

      const metricConfig = getMetricConfig(
        ((metric as string) || "").split("\\")[0] as ApiMetric,
      );
      return metricConfig.format
        ? metricConfig.format(value || 0, currency, options)
        : options?.isKM
          ? formatToKM(value || 0)
          : formatNumber(value || 0);
    },
    [selectedProject],
  );
};
export default useFormatMetric;
